import { handleActions } from 'redux-actions';
import * as actions from '../../Actions/emailExample';

export const initialState = {
    testInvitationSentPastOrders: false,
    testInvitationSentProductReviews: false,
};

const emailExample = handleActions<any>(
    {
        [actions.emailSent]: (state, { payload }) => ({
            ...state,
            ...payload,
        }),
    },
    initialState,
);

export default emailExample;
